jQuery($ => {
    class QuoteQuantity {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._input     = this._element.find('.m-quote-quantity__input');
        this._hidden    = this._element.closest('.gfield_list_group').find('input[type="hidden"][name^="input_"]');
        this._form      = this._element.closest('form');
        this._timer     = null;
        this._pending   = null;
        this._submitted = false;

        this.init();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupHandlers() {
        this._element.find('.m-quote-quantity__btn--minus').on('click', () => this.step(-1));
        this._element.find('.m-quote-quantity__btn--plus').on('click', () => this.step(1));
        this._input.on('input change', () => this.handleChange());

        // Submitting: the hidden field already holds the right value and the cart
        // gets emptied server-side, so drop any pending background update
        this._form.on('submit', () => {
          this._submitted = true;
          clearTimeout(this._timer);
          this._pending = null;
        });

        // Leaving/refreshing before the debounce fires: flush the update
        $(window).on('pagehide', () => this.flush());
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Quantity handling
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getQuantity() {
        return Math.max(1, parseInt(this._input.val(), 10) || 1);
      }

      step(delta) {
        this._input.val(Math.max(1, this.getQuantity() + delta));
        this.handleChange();
      }

      handleChange() {
        // Allow the field to be temporarily empty while typing
        if (this._input.val() === '') return;

        const quantity = this.getQuantity();
        this._input.val(quantity);

        // Instant: the hidden field is what gets submitted to GF
        const id = (this._hidden.val() || '').replace(/:\d+$/, '');
        this._hidden.val(`${id}:${quantity}`);

        // Background: keep the cart in sync so a refresh shows the same quantity
        this._pending = quantity;
        clearTimeout(this._timer);
        this._timer = setTimeout(() => this.sync(), 400);
      }

      getPayload() {
        return {
          action: 'update_quote_item_quantity',
          cart_item_key: this._element.data('cart-key'),
          nonce: this._element.data('nonce'),
          quantity: this._pending,
        };
      }

      sync() {
        if (this._pending === null || this._submitted) return;

        const payload = this.getPayload();
        this._pending = null;

        $.post(AJAX.url, payload).fail(error => console.error(error));
      }

      flush() {
        clearTimeout(this._timer);
        if (this._pending === null || this._submitted) return;

        const payload = this.getPayload();
        this._pending = null;

        if (navigator.sendBeacon) {
          navigator.sendBeacon(AJAX.url, new URLSearchParams(payload));
        } else {
          $.ajax({ type: 'POST', url: AJAX.url, data: payload, async: false });
        }
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.quote_quantity = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].quote_quantity = new QuoteQuantity(_[i], opt);
        else
          ret = _[i].quote_quantity[opt].apply(_[i].quote_quantity, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    const initAll = () => $('.m-quote-quantity').not('.is-initialized').addClass('is-initialized').quote_quantity();

    initAll();

    // Re-init when Gravity Forms re-renders the form via AJAX (e.g. failed validation)
    $(document).on('gform_post_render', initAll);
});
